import React from 'react';
import { ActionStripV2 } from '../ActionStripV2';
export var A4_ActionStripV2 = function A4_ActionStripV2(props) {
  return /*#__PURE__*/React.createElement(ActionStripV2, props);
};